"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiIconButtonDownload = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customProps = require("../../utils/customProps");

var _downloadUrl = _interopRequireDefault(require("../../utils/downloadUrl"));

var _MuiIconButton = _interopRequireDefault(require("../MuiIconButton/MuiIconButton"));

/**
 * MuiIconButtonDownload is used in storyblok that will download a href
 */
var MuiIconButtonDownload = function MuiIconButtonDownload(_ref) {
  var href = _ref.href,
      fileName = _ref.fileName,
      iconButton = _ref.iconButton;

  var onClick = function onClick() {
    (0, _downloadUrl.default)(href, fileName);
  };

  var muiIconButton = iconButton[0];
  return /*#__PURE__*/_react.default.createElement(_MuiIconButton.default, (0, _extends2.default)({}, muiIconButton, {
    onClick: onClick
  }));
};

exports.MuiIconButtonDownload = MuiIconButtonDownload;
var _default = MuiIconButtonDownload;
exports.default = _default;
MuiIconButtonDownload.propTypes = {
  /** url of the file you want to be downloaded */
  href: _propTypes.default.string.isRequired,

  /** name of file */
  fileName: _propTypes.default.string.isRequired,

  /** MuiIconButton Allowed maximum: 1 */
  iconButton: function iconButton(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiIconButton'], 1);
  }
};
MuiIconButtonDownload.defaultProps = {
  iconButton: []
};